import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
import country from '@/data/country.json'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: localStorage.getItem('access_token') || null,
        role: localStorage.getItem('role') || null,
        country: country,
        jobsite: [],
        users: [],
    },
    getters: {
        loggedIn(state) {
            return state.token !== null
        },
        roleIn(state) {
            return state.role !== null
        },
        pathBase() {
            return process.env.VUE_APP_API_URL.replace('/api','/');
        }
    },
    mutations: {
        SET_JOBSITE(state, jobsite) {
            state.jobsite = jobsite
        },
        SET_USERS(state, users) {
            state.users = users
        },
        retrieveToken(state, token) {
            state.token = token
        },
        retrieveRole(state, role) {
            state.role = role
        },
        destroyToken(state) {
            state.token = null
        },
    },
    actions: {
        verifyAccess() {
            const pathMenu = router.currentRoute.path;
            return new Promise((resolve, reject) => {
                axios.get(`/menu/verifyAccessMenuByRol?idRol=${localStorage.getItem('role')}&pathMenu=${pathMenu}`)
                    .then(res => {
                        const genericResponse = res.data;
                        if (genericResponse.isError == true) {
                            //Logout
                            router.push({ name: 'Logout' })
                        }

                        resolve();
                    })
                    .catch(e => {
                        console.error('error' + e.message)
                        reject();
                    })
            })
        },
        getMenu() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/menu')
                    .then(response => {
                        var genericResponse = response.data;
                        resolve(genericResponse)
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        getJobsite({ commit }) {
            axios
                .get('/jobsite')
                .then(data => {
                    let jobsite = data.data.data
                    commit('SET_JOBSITE', jobsite)
                })
                .catch(e => {
                    console.error('error' + e)
                })
        },
        getUser() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/user')
                    .then(response => {
                        resolve(response);
                    })
                    .catch(e => {
                        console.error('error' + e)
                        reject(e);
                    })
            });
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/auth/local', {
                        email: credentials.email,
                        password: credentials.password,
                    })
                    .then(response => {
                        const  genericResponse = response.data;
                        if (genericResponse.isError == false) {
                            const token = genericResponse.result.access_token
                            const role = genericResponse.result.idRole
                            localStorage.setItem('access_token', token)
                            localStorage.setItem('role', role)
                            context.commit('retrieveToken', token)
                        }

                        resolve(genericResponse)
                    })
                    .catch(error => {
                        console.error("*** err ***", error)
                        reject(error)
                    })
            })
        },
        destroyToken(context) {
            axios.defaults.headers.common['Authorization'] = context.state.token
            if (context.getters.loggedIn) {
                return new Promise((resolve, reject) => {
                    axios
                        .post('/auth/logout')
                        .then(response => {
                            localStorage.removeItem('access_token')
                            context.commit('destroyToken')

                            resolve(response)
                        })
                        .catch(error => {
                            localStorage.removeItem('access_token')
                            context.commit('destroyToken')

                            reject(error)
                        })
                })
            }
        },
        getEmails(context) {
            axios.defaults.headers.common['Authorization'] = context.state.token
            return new Promise((resolve, reject) => {
                axios
                    .get('/mail/readMails')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getConfigEmail(context) {
            axios.defaults.headers.common['Authorization'] = context.state.token
            return new Promise((resolve, reject) => {
                axios
                    .get('/mail/config')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    },
    modules: {},
})
